import { useEffect } from "react";

const ADSENSE_CLIENT = "ca-pub-2579925809542047";
// Paste your AdSense "data-ad-slot" (AdSense → Ads → By ad unit → Display ads) here
// to activate the manual ad unit below the tool widget. Auto Ads works without it.
const ADSENSE_SLOT = "";

export function AdUnit({ className = "" }) {
  const enabled = Boolean(ADSENSE_SLOT);

  useEffect(() => {
    if (!enabled) return;
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch {}
  }, [enabled]);

  if (!enabled) return null;

  return (
    <div className={`my-8 ${className}`} data-testid="ad-unit">
      <ins
        className="adsbygoogle"
        style={{ display: "block" }}
        data-ad-client={ADSENSE_CLIENT}
        data-ad-slot={ADSENSE_SLOT}
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
    </div>
  );
}
